import * as React from 'react';

import classnames from 'classnames';

import {getDurationMinutesText} from 'nutshell-core/get-duration-minutes-text';

import {colors} from 'shells/colors/colors';
import {HalfAndHalfIcon} from 'shells/icon/svg/half-and-half-icon';
import {ProgressBar} from 'shells/progress-bar/progress-bar';

import styles from './results-banner-container.module.css';

type Props = {
    isLoading: boolean;
    headerText: string | React.ReactNode;
    subheaderText: string | React.ReactNode;
    percentComplete?: number;
    minutesRemaining?: number | null | undefined;
    hasWinner?: boolean;
};

export function ResultsBannerContainer(props: Props) {
    const shouldShowProgressBar = props.minutesRemaining && !props.hasWinner;

    return (
        <>
            <div className={classnames('flex align-center', styles.banner)}>
                <div className='mr-16'>
                    <HalfAndHalfIcon size={24} />
                </div>
                <div className='flex flex-dir-col'>
                    <div className='font-bold font-size-normal mb-4'>
                        {props.isLoading ? '' : props.headerText}
                    </div>
                    <div>{props.isLoading ? '' : props.subheaderText}</div>
                </div>
            </div>
            {shouldShowProgressBar ? (
                <ProgressBar
                    tooltipText={`${getDurationMinutesText(props.minutesRemaining || 0)} remaining`}
                    percentComplete={(props.percentComplete || 1) / 100}
                    height={15}
                    color={colors.grey}
                />
            ) : null}
        </>
    );
}
